import React from "react";
import { SR_CHAT_SUGGESTIONS } from "../sr-constants";

type Props = {
    disabled?: boolean;
    onPick: (text: string) => void;
};

export const SrChatSuggestions: React.FC<Props> = ({ disabled, onPick }) => (
    <div className="flex flex-wrap gap-2 px-1 pb-1">
        {SR_CHAT_SUGGESTIONS.map((label) => (
            <button
                key={label}
                type="button"
                disabled={disabled}
                onClick={() => onPick(label)}
                className="sr-chat-suggest rounded-full border border-slate-200 bg-white px-3 py-1.5 text-slate-600 shadow-sm transition hover:border-[#3A80F4]/40 hover:bg-[#3A80F4]/5 hover:text-[#2563EB] disabled:opacity-50"
            >
                {label}
            </button>
        ))}
    </div>
);
